import React, { useState, useEffect } from "react";
import { Tab, Tabs, Container, Col, Card } from "react-bootstrap";
import Header_PartnerJazzcash from "../Components/PartnerJazzcash/Header_PartnerJazzcash";
import PartnerDashboard from "../Components/PartnerJazzcash/PartnerDashboard";
import TotalRecord from "../Components/PartnerJazzcash/TotalRecord";
import ActiveAgent from "../Components/PartnerJazzcash/ActiveAgent";
const Dashboard = () => {
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const user = JSON.parse(sessionStorage.getItem("user"));
    if (user) {
      setUserData(user);
    } else {
      console.log("No user found in sessionStorage");
    }
  }, []);

  if (userData && userData.userRole === "JazzCash") {
    return (
      <div className="container-fluid">
        <Header_PartnerJazzcash />

        <Container className="mt-4">
          <Col>
            <Card className="shadow-lg">
              <Card.Header>
                <h4 className="text-center">Dashboard</h4>
              </Card.Header>

              <Card.Body>
              <ActiveAgent />

                
                <Tabs defaultActiveKey="monthly" id="dashboard-tabs" className="mb-3" justify>
                <Tab eventKey="monthly" title="Month Wise Data">
                    <div className="pt-3">
                      <PartnerDashboard />
                    </div>
                  </Tab>

                  <Tab eventKey="total" title="Total Data">
                    <div className="pt-3">
                      <TotalRecord />
                    </div>
                  </Tab>

                 
                </Tabs>
              </Card.Body>
            </Card>
          </Col>
        </Container>
      </div>
    );
  } else {
    return (
      <div className="text-center mt-5">
        You do not have permission to view this page.
      </div>
    );
  }
};

export default Dashboard;
